import { Injectable } from '@angular/core';
import { Http,Response, Headers,RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/catch';
import {Observable} from "rxjs";
import {Combo} from "../combo/combo";
import {AuthenticationService} from "../Login/authentication.service";
import {UrlService} from "./url.service";



@Injectable()
export class ComboService
{

  private headers = new Headers({'Content-Type':'application/json',
    'Authorization': 'Bearer ' + this.authenticationService.token });//parametrizamos a json
  private options = new RequestOptions({ headers: this.headers });
  private url = this.URL.getLocal()+'/combo';//Url que maeja GET ,POST
  private urlAsignacion = this.URL.getLocal()+'/comboproducto';//Url que maeja GET ,POST
  private urlById = this.URL.getLocal()+'/comboproducto/';//busca un Combo por cedulachivos
  private urlcomboByTienda = this.URL.getLocal()+'/combo/tienda/';//busca un Combo por cedulachivos
  private urlPut = this.URL.getLocal()+'/combo/';//la direccion a la cual se conecta


  //Constructor de la clase
  constructor(private URL:UrlService,private http:Http, private authenticationService: AuthenticationService)
  {
    //this.headers.append('Content-Type', 'application/x-www-form-urlencoded');
    //this.headers.append('X-Requested-With', 'XMLHttpRequest');
  }
  //Obtiene una lista de Combos
  getCombo():Observable<Combo[]> {
    let url = `${this.url}`;
    return this.http.get(url,this.options)
      .map(r => r.json())
      .catch(this.handleError)
  }
  getComboByTienda(id: number): Observable<any[]> {
    let url = `${this.urlcomboByTienda}${id}`;
    return this.http.get(url, this.options)
      .first()
      .map(r => r.json())
      .catch(this.handleError)
  }
  getDetallesByCombo(id: number): Observable<any[]> {
    let url = `${this.urlById}${id}`;
    return this.http.get(url, this.options)
      .first()
      .map(r => r.json())
      .catch(this.handleError)
  }

  addCombo(Combo:Combo) {
    let url = `${this.url}`;
    let iJson = JSON.stringify(Combo);
    return this.http.post(url,iJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);

  }
  asignarUsuario(Datos:Combo) {
    let url = `${this.urlAsignacion}`;
    let iJson = JSON.stringify(Datos);
    return this.http.post(url,iJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);

  }
  putCombo(Combo : Combo,id:number){
    let url = `${this.urlPut}${id}`;
    let CJson = JSON.stringify(Combo);
    return this.http.put(url,CJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);
  }
//Este metodo detecta un error en la llamada a http
  private handleError(error : Response | any) {
    let errMsj : string;
    if(error instanceof Response)
    {
      let body  = error.json() || '';
      let err = body.error || JSON.stringify(body);
      errMsj = `${error.status} - ${error.statusText || ''} ${err}`;
    }
    else
    {
      errMsj = error.message ? error.message : error.Tostring();
    }
    return Observable.throw(errMsj);
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/Services/combo.service.ts